import type { SVGProps } from 'react';
const CloseButton = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width={32}
        height={32}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <g filter="url(#filter0_i_1493_75795)">
            <rect width={32} height={32} rx={16} fill="white" />
            <path
                d="M20.5 11.5L11.5 20.5"
                stroke="#F39E4E"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.5 20.5L11.5 11.5"
                stroke="#F39E4E"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x={0.5} y={0.5} width={31} height={31} rx={15.5} stroke="#F39E4E" />
        </g>
        <defs>
            <filter
                id="filter0_i_1493_75795"
                x={0}
                y={0}
                width={32}
                height={33}
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity={0} result="BackgroundImageFix" />
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy={1} />
                <feGaussianBlur stdDeviation={6} />
                <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_1493_75795" />
            </filter>
        </defs>
    </svg>
);
export default CloseButton;
